import Vue from 'vue';

const apiPrefix = '/api/v1';
export const placementActivityService = {
  getPlacementActivity: function(placementActivityInputParams, offsetParams) {
    const queryParams = this.transformParams(placementActivityInputParams);
    return Vue.axios
      .get('/placement-activity', {
        params: {
          ...queryParams,
          ...offsetParams
        }
      })
      .then(response => response.data);
  },
  getPlacementActivitySummary: function(placementActivityInputParams, summaryType) {
    const queryParams = this.transformParams(placementActivityInputParams);
    return Vue.axios
      .get('/placement-activity/activity-summary', {
        params: {
          ...queryParams,
          ...summaryType
        }
      })
      .then(response => response.data);
  },
  getPlacementActivityRecordCount(params) {
    const queryParams = this.transformParams(params);
    return Vue.axios
      .get('/placement-activity/count', {
        params: {
          ...queryParams
        }
      })
      .then(response => response.data);
  },
  getPlacementActivitySummaryStream(params, auth) {
    const queryParams = this.transformParams(params);
    const url = this.appendQueryParams(
      `${apiPrefix}/placement-activity/count-records`,
      queryParams
    );
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth}`
      }),
      referrerPolicy: 'strict-origin-when-cross-origin'
    })
      .then(async response => {
        const reader = response.body.getReader();
        let parsedData = [];
        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { done, value } = await reader.read();

          if (done) {
            break;
          }

          const parsed = new TextDecoder('utf-8').decode(value);
          const parsedArr = parsed.split('§').filter(item => item.length !== 0);
          parsedData = parsedData.concat(...parsedArr);
        }
        const jsonData = parsedData.map(d => JSON.parse(d));
        const keyMap = {
          0: 'weekly',
          1: 'givenRange',
          2: 'yearly',
          3: 'monthly',
          4: 'quarterly'
        };

        return jsonData.reduce((acc, data, idx) => {
          acc[keyMap[idx]] = data;
          return acc;
        }, {});
      })
      .then(data => data)
      .catch(err => console.log(err));
  },
  appendQueryParams(url, params) {
    let q = '';
    for (let key in params) {
      q += `${key}=${params[key]}&`;
    }
    return url + `?${q.slice(0, -1)}`;
  },
  //helper method to convert dates (Date object) in query params to string
  transformParams(params) {
    let queryParams = { ...params };
    queryParams.rangeStart = queryParams.rangeStart.toISOString();
    queryParams.rangeEnd = queryParams.rangeEnd.toISOString();

    return queryParams;
  }
};
